import styled from 'styled-components';

export const FoundProvidersContainer = styled.div.attrs(() => ({}))`
  & .found_items_text {
    margin-bottom: 20px;
    margin-left: 16px;
  }
`;
